"use client";

import { useSetScrollbarSize } from "@/hooks/use-set-scroll-bar-size";

/**
 * Component that detects and sets the root scrollbar size CSS variable
 * when the screen size changes to 4xl breakpoint.
 */
export function SetScrollbarSize() {
  useSetScrollbarSize();
  return null;
}